<!-- 已选单元 -->
<template>
  <div class='yetSelectWard'>
    <div class="header df-between" :style="{'padding-top':utils.isIphoneX()?'50px':'30px'}">
      <img src="../../assets/images/i-arrow-left.png" alt="" @click='handleBack' >
      <div class="title">已选负责单元</div>
      <span class='addWard' @click='handleBack'>添加</span>
    </div>
    <div class="container">
      <div class="item" v-for='(item1,index1) in deptData' :key='index1'>
        <div class="item-title" v-if='item1.districtWardNumber.length>0'>
          <h3>{{item1.name}}</h3>
          <span @click='handleIsFlod(index1)'>已选{{item1.districtWardNumber.length}}</span>
        </div>
        <div v-for='(item2,index2) in item1.children' :key='index2'>
          <template v-if='item2.groupResult.length>0'>
            <template v-if='item1.isFlod'>
              <div v-for='(item3,index3) in item2.children' :key='index3'>
                
                <!-- <div class="item-content df-between" v-if="item4.isSelected == 1" v-for='(item4,index4) in item3.wards' :key='index4'>
                  <span>{{item4.inpatientArea}}-{{item3.name}}</span>
                  <img @click='handleDelWard(index1,index2,index3,index4,item4.id)'  src="../../assets/images/dept-close1.png" alt="">
                </div> -->

                <div v-for='(x,y) in listData' :key='y'>
                  <div class="item-content df-between" v-if="item4.id == x" v-for='(item4,index4) in item3.wards' :key='index4'>
                    <span>{{item4.inpatientArea}}-{{item3.name}}</span>
                    <img @click='handleDelWard(index1,index2,index3,index4,item4.id)' v-if='reportStatus=="0"'  src="../../assets/images/dept-close1.png" alt="">
                  </div>
                </div>
              </div>
            </template>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props:['deptData','yetSelectWards','totalWardNumber'],
    data() {
      return {
        reportStatus:"0",
        listData:[]
      }
    },
    created() {
      this.reportStatus = localStorage.getItem('reportStatus')
    },
    mounted(){
    },
    watch:{
      yetSelectWards(){
        this.listData = this.yetSelectWards
      },
      totalWardNumber(){
        this.listData = this.totalWardNumber
      }
    },
    methods: {
      handleBack(){
        this.$emit('handlleCloseYetSelectWard')
      },
      handleIsFlod(index1){
        this.deptData[index1].isFlod = !this.deptData[index1].isFlod
      },
      handleDelWard(index1,index2,index3,index4,id){
        this.$emit('delWard',index1,index2,index3,index4,id)
      }
    },
  }
</script>
<style lang='scss' scoped>
  .yetSelectWard {
    display: flex;
    flex-direction: column;
    height: 100vh;
    .header {
      padding: 15px 15px 15px 5px;
      color: #000;
      img {
        width: 22px;
        height: 22px;
      }
      .title {
        font-size: 17px;
      }
      .addWard {
        color: #404040;
        font-size: 14px;
      }
    }
    .container{
      overflow: scroll;
      .item{
        .item-title{
          height: 40px;
          padding: 0px 12px;
          display: flex;
          align-items: center;
          background-color: #f2f2f2;
          font-family: PingFang, PingFang-SC;
          font-weight: SC;
          h3{
            margin-right: 10px;
            color: #404040;
            font-size: 16px;
          }
          span{
            color: #26b4ff;
            font-size: 13px;
          }
        }
        .item-content{
          height: 44px;
          margin-left: 25px;
          padding-right: 12px;
          border-bottom: 1px solid #eee;
          font-family: PingFang, PingFang-SC;
          font-weight: SC;
          color: #404040;
          font-size: 14px;
          img{
            width: 22px;
            height: 22px;
          }

        }
      }
    }
  }
</style>